import {
  ReportChannels,
  ReportPaymentMethods,
  ReportPeriodRange,
} from '../redux-toolkits/reports/reports.type'

export const COOKIE_KEY = process.env.REACT_APP_AUTH_COOKIE_KEY! ?? '@goo'
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL
export const IMAGES_BACKEND_BASE_URL =
  process.env.REACT_APP_IMAGES_BACKEND_BASE_URL
export const IS_LIVE = Boolean(Number(process.env.REACT_APP_IS_LIVE ?? 0))
export const CURRENT_PAGE_NUMBER = 1
export const NUMBER_OF_ITEMS_PER_PAGE = 20
export const MAX_NO_PUBLISHED_LISTS = 10
export const PRIMARY_COLOR = '#F45D2C'
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY ?? ''
export const SKELETON_BASE_COLOR = '#f3f4f6'
export const SKELETON_HIGHLIGHT_COLOR = '#ffffff80'

export const SETTLEMENTSTATUS = [
  {
    id: 1,
    name: 'SUCCESS',
    type: 'success',
  },
  {
    id: 2,
    name: 'FAILED',
    type: 'fail',
  },
  {
    id: 3,
    name: 'PENDING_CONFIRMATION',
    type: 'warn',
  },
  {
    id: 4,
    name: 'PENDING',
    type: 'warn',
  },
  {
    id: 5,
    name: 'COMPLETED',
    type: 'success',
  },
]

export const partyMappings = {
  GOOD_THING: 'Good Operations',
  OTHERS: 'Others',
  REFERRAL: 'Referral',
}

export const DISABLE__DELIVERY_REQUEST__FROM = 6

export const settlementFilter = {
  all: { name: 'All', value: 'all' },
  VENDOR: { name: 'Vendor', value: 'VENDOR' },
  GOOD_THING: { name: 'Good Operations', value: 'GOOD_THING' },
  OTHERS: { name: 'Others', value: 'OTHERS' },
}

export const ReportChannelsMap: Record<
  ReportChannels,
  {
    name: string
    color: string
  }
> = {
  ANDROID_MOBILE: {
    name: 'Good Android',
    color: '!bg-amber',
  },
  IOS_MOBILE: {
    name: 'Good IOS',
    color: '!bg-red-650',
  },
  ONLINE: {
    name: 'Good Web',
    color: '!bg-cust-green',
  },
  POP: {
    name: 'Good House',
    color: '!bg-lime-green',
  },
  GOOD_HOUSE_PHYSICAL: {
    name: 'Good House',
    color: '!bg-lime-green',
  },
}

export const ReportPaymentMethodsMap: Record<
  ReportPaymentMethods,
  {
    name: string
    color: string
  }
> = {
  DEBIT: {
    name: 'Good Wallet',
    color: '!bg-amber',
  },
  WALLET: {
    name: 'Good Wallet',
    color: '!bg-amber',
  },
  card: {
    name: 'Card',
    color: '!bg-lime-green',
  },
  pos: {
    name: 'POS',
    color: '!bg-cust-green',
  },
  bank_transfer: {
    name: 'Bank Transfer',
    color: '!bg-red-650',
  },
}

export const PeriodTextMap: Record<ReportPeriodRange, string> = {
  last_month: 'month',
  last_week: 'week',
  last_year: 'year',
  this_month: 'month',
  this_week: 'week',
  this_year: 'year',
  today: 'day',
  yesterday: 'day',
  inception_to_date: '',
}
